import React, { useContext, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { IconButtonOutlined } from "../utils/IconButtonOutlined";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import { SkillDetails, UserCtx } from "../../../interfaces";
import { UserContext } from "../../../context/UserContext";

interface VideoListItemProps {
  skillVideoDetails: SkillDetails;

  onClick?: () => void;
  // Adding this function to accommodate data layer changes
  onBookmarkClick: (skillTitle: string, toggleState: boolean) => void;
}

export const VideoListItem = (props: VideoListItemProps) => {
  let { skillVideoDetails, onBookmarkClick } = props;
  const userCtx = useContext(UserContext) as UserCtx;
  const [isSaved, setIsSaved] = useState(false);
  useEffect(() => {
    if (!skillVideoDetails.skill_id) return;
    setIsSaved(userCtx.checkSkillSaved(skillVideoDetails?.skill_id));
  }, [skillVideoDetails.skill_id, userCtx]);
  const [hover] = useState(true);
  const handleSave = (e: React.MouseEvent<HTMLButtonElement>, skillId?: string) => {
    e.stopPropagation();
    if (!skillId) return;
    userCtx.toggleSavedSkill(skillId);
  };

  return (
    <Box
      tabIndex={0}
      onClick={props.onClick}
      sx={{
        minWidth: "276px",
        minHeight: "155px",
        borderRadius: "15px",
        padding: "10px",
        "&:hover": {
          background: "#F2F2F2 0% 0% no-repeat padding-box",
        },
        position: "relative",
        display: "flex",
        gap: "16px",
        cursor: "pointer",
      }}
      // onMouseEnter={() => setHover(true)}
      // onMouseLeave={() => setHover(false)}
    >
      <Box
        sx={{
          position: "relative",
          height: "155px",
          width: "276px",
          minWidth: "276px",
          borderRadius: "15px",
          marginBottom: "6px",
          backgroundColor: skillVideoDetails.metadata?.videoThumbnail
            ? "#000000"
            : "#F2F2F2",
          backgroundImage: `url(${
            skillVideoDetails.metadata !== null
              ? skillVideoDetails.metadata?.videoThumbnail
              : "https://placehold.jp/CCCCCC/ffffff/276x155.png?text=%20"
          })`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}>
        {/*<Box sx={{*/}
        {/*    position: "absolute",*/}
        {/*    bottom: "10px",*/}
        {/*    right: "10px",*/}
        {/*    color: "#ffffff",*/}
        {/*    backgroundColor: "rgba(0,0,0,0.54)",*/}
        {/*    borderRadius: "8px",*/}
        {/*    fontSize: "12px",*/}
        {/*    padding: "1px 8px",*/}
        {/*    textAlign: "center"*/}
        {/*}}>*/}
        {/*    <span>3:00</span>*/}
        {/*</Box>*/}
      </Box>
      <Box sx={{ marginTop: "16px" }}>
        <Typography
          variant="body2"
          sx={{
            fontSize: "20px",
            fontWeight: "bold",
            marginBottom: "8px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "2",
            WebkitBoxOrient: "vertical",
            maxWidth: "560px",
          }}>
          {skillVideoDetails.title}
        </Typography>

        {hover ? (
          <IconButtonOutlined
            sx={{
              marginLeft: "auto",
              width: "40px",
              height: "40px",
              position: "absolute",
              right: "10px",
              top: "10px",
            }}
            hover={<BookmarkIcon style={{ width: "24px", height: "24px" }} />}
            tooltipLabel={isSaved ? "Remove from saved videos" : "Save video"}
            tooltipPlacement="bottom"
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              handleSave(e, skillVideoDetails.skill_id);
              onBookmarkClick(skillVideoDetails.title, !isSaved);
            }}>
            {isSaved ? (
              <BookmarkIcon style={{ width: "24px", height: "24px" }} />
            ) : (
              <BookmarkBorderOutlinedIcon style={{ width: "24px", height: "24px" }} />
            )}
          </IconButtonOutlined>
        ) : null}
      </Box>
    </Box>
  );
};
